import { render, staticRenderFns } from "./CommodityView.vue?vue&type=template&id=2883afd3&scoped=true&"
import script from "./CommodityView.vue?vue&type=script&lang=js&"
export * from "./CommodityView.vue?vue&type=script&lang=js&"
import style0 from "./CommodityView.vue?vue&type=style&index=0&id=2883afd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2883afd3",
  null
  
)

export default component.exports